import styled from 'styled-components';

const Popover = styled.span`
    position: relative;
}
`;
export default Popover;
